import React from 'react';
import Tippy from '@tippyjs/react';
import { SortableElement } from 'react-sortable-hoc';
import moment from 'moment';
import DragHandle from './DragHandle';
import PageDropDown from '../page/PageDropDown';
import AuthorAvatar from '../page/AuthorAvatar';
import { getPageUrlFromSlug } from '../../utilities/urlHelper';
import { decodeHtmlEntities } from '../../utilities/sanitizeHTML';

class PageListItem extends React.Component {
    render() {
        const {
            page, isDraggable, moveMode, isInFolder,
        } = this.props;
        const updatedAt = moment.utc(page.updated_at).local().fromNow();

        return (
            <tr className={this.props.isInFolder ? 'in-folder-list-item' : ''}>
                <td className={(!isDraggable && page.is_pinned) ? 'list-item-name flex no-drag-handle' : 'list-item-name flex'}>
                    { moveMode && <input type="checkbox" className="bulk-action-checkbox" checked={!!page.isChecked} onChange={() => this.props.checkItem(page)} /> }
                    {isDraggable && <DragHandle />}
                    <img className="page-list-icon" height="24" width="24" src="/img/icons/file-icon-page.png" />
                    <div className="flex-auto">
                        <h4 className="page-list-title" data-page-id={page.id}>
                            <a href={getPageUrlFromSlug(page.slug)}>
                                {decodeHtmlEntities(page.title)}
                                {
                                    !!page.is_pinned
                                    && (
                                        <Tippy content="Pinned page" placement="right">
                                            <img
                                                src="/img/icons/pin.png"
                                                className="ml1"
                                                height="16"
                                                alt="Pinned page"
                                            />
                                        </Tippy>
                                    )
                                }
                            </a>
                        </h4>
                    </div>
                </td>
                <td className="list-item-data">
                    {updatedAt}
                </td>
                <td className="list-item-data">
                    <AuthorAvatar userId={page.user_id} user={page.user} imgHeight="24" imgWidth="24" />
                </td>
                <td className="list-item-actions">
                    <PageDropDown {...this.props} />
                </td>
            </tr>
        );
    }
}

const SortablePageListItem = SortableElement(PageListItem);

export { SortablePageListItem, PageListItem };
